import { render, staticRenderFns } from "./cmsPreview.vue?vue&type=template&id=115216d1&scoped=true&"
import script from "./cmsPreview.vue?vue&type=script&lang=js&"
export * from "./cmsPreview.vue?vue&type=script&lang=js&"
import style0 from "./cmsPreview.vue?vue&type=style&index=0&id=115216d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115216d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/app/components/banner.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
